<nz-tabset
  [nzTabBarExtraContent]="extraTemplate"
  nzTabPosition="top"
  [(nzSelectedIndex)]="selectedIndex"
>
  <ng-template #extraTemplate>
    <un-button (btnClick)="add.emit()"
      ><un-icon type="plus-circle" theme="outline"></un-icon>
      <span i18n>Add</span></un-button
    ></ng-template
  >
  @for (control of formArr.controls; track control; let i = $index) {
  <nz-tab [nzTitle]="titleTemp">
    <ng-template #titleTemp>
      <div class="d-flex">
        <span [ngClass]="{ error: control.invalid && control.dirty }">{{
          ((tabTitleFn && tabTitleFn(i)) || tabTitle + ' ' + (i + 1)) +
            (control.invalid ? ' *' : '') | unTitleCase
        }}</span>
        @if (showClose(i)) {
        <un-icon
          class="m-l-8 close"
          type="close"
          theme="outline"
          (click)="formArr.removeAt(i)"
        ></un-icon>
        }
      </div>
    </ng-template>
    <template
      [ngTemplateOutlet]="formTmp || tmpl"
      [ngTemplateOutletContext]="{control}"
    ></template>
  </nz-tab>
  } @if (formArr.controls.length === 0) {
  <nz-tab></nz-tab>
  }
</nz-tabset>
